"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosDuplicateInterceptor = void 0;
const utils_1 = require("./utils");
// import type { AxiosRequestConfig } from 'axios';
class AxiosCancel {
    constructor() {
        this.pendingMap = new Map();
    }
    generateReqKey(config) {
        const { method, url, params, data } = config;
        return [url || '', method || '', (0, utils_1.qs)(params || {}), (0, utils_1.qs)(data || {})].join('&');
    }
    addPendingRequest(config) {
        const key = this.generateReqKey(config);
        if (this.pendingMap.has(key)) {
            const controller = this.pendingMap.get(key);
            controller === null || controller === void 0 ? void 0 : controller.abort();
        }
        const controller = new AbortController();
        config.signal = controller.signal;
        this.pendingMap.set(key, controller);
    }
    removePendingRequest(config) {
        const key = this.generateReqKey(config);
        this.pendingMap.delete(key);
    }
}
class AxiosDuplicateInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.axiosCancel = new AxiosCancel();
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    addRequestInterceptor() {
        this.axiosInstance.registerRequestInterceptor((config) => {
            if (config.duplicate) {
                this.axiosCancel.addPendingRequest(config);
            }
            return config;
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor((response) => {
            var _a;
            if ((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.duplicate) {
                this.axiosCancel.removePendingRequest(response.config);
            }
            return response;
        }, (error) => {
            var _a;
            // || error.code === 'ERR_BAD_REQUEST'
            if ((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.duplicate) {
                if (error.code === 'ERR_CANCELED')
                    return Promise.reject(error);
                this.axiosCancel.removePendingRequest(error.config);
            }
            return Promise.reject(error);
        });
    }
}
exports.AxiosDuplicateInterceptor = AxiosDuplicateInterceptor;
//# sourceMappingURL=AxiosDuplicateInterceptor.js.map